import { Link } from "react-router-dom";

export interface Crumb {
  label: string;
  to?: string;
}

export default function Breadcrumb({ items }: { items: Crumb[] }) {
  return (
    <nav aria-label="面包屑导航" className="text-sm text-foreground-500">
      <ol className="flex flex-wrap items-center gap-2">
        {items.map((item, index) => (
          <li key={`${item.label}-${index}`} className="flex items-center gap-2">
            {item.to ? (
              <Link to={item.to} className="transition hover:text-primary-600">
                {item.label}
              </Link>
            ) : (
              <span className="font-medium text-foreground-800">{item.label}</span>
            )}
            {index < items.length - 1 && <i className="ri-arrow-right-s-line text-foreground-300"></i>}
          </li>
        ))}
      </ol>
    </nav>
  );
}